import React, { useState } from 'react';
import type { DossierOpportunityRef } from '../../../services/CrmDossierService';

interface Props {
  itemId: string;
  others: DossierOpportunityRef[];
  disabled?: boolean;
  onMove: (itemId: string, targetCardId: number) => void;
}

/** Corrige a atribuição: leva o item para outra oportunidade do mesmo cliente (vínculo manual na oportunidade escolhida). */
const DossierMoveMenu: React.FC<Props> = ({ itemId, others, disabled, onMove }) => {
  const [open, setOpen] = useState(false);
  if (others.length === 0) return null;
  return (
    <span className="dossier-move">
      <button type="button" className="dossier-btn" disabled={disabled} aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        Mover para outra oportunidade
      </button>
      {open && (
        <ul className="dossier-move__list">
          {others.map((o) => (
            <li key={o.id}>
              <button
                type="button"
                className="dossier-btn"
                disabled={disabled}
                onClick={() => {
                  setOpen(false);
                  onMove(itemId, o.id);
                }}
              >
                {[o.title ?? 'Oportunidade sem assunto', o.columnName, o.isClosed ? 'Encerrada' : null].filter(Boolean).join(' · ')}
              </button>
            </li>
          ))}
        </ul>
      )}
    </span>
  );
};

export default DossierMoveMenu;
